// -----------------------------------------------------------------------------
// Mobile nav toggler
// -----------------------------------------------------------------------------

const navToggler = document.querySelector('.js-menu-toggle')
const navMenu = document.querySelector('.js-menu')

navToggler.addEventListener('click', (e) => {
  const isOpen = navToggler.getAttribute('aria-expanded') === 'false'
  navToggler.setAttribute('aria-expanded', isOpen)
  navMenu.classList.toggle('open')
})
